export const routes = {
  home: '/',
  signin: '/signin',
  signout: '/signout',
  users: '/users',
  matches: '/matches',
  prediction: '/prediction',
  predictionResult: '/prediction-result',
  settings: '/settings',
  whitelist: '/whitelist'
};
